import React from 'react'
import { Unit } from '../../graphql/api/types'

const unitsContext = React.createContext<Unit[]>([])

unitsContext.displayName = 'UnitsContext'

export { unitsContext as UnitsContext }
